document.addEventListener('DOMContentLoaded', function () {
  const PVC_CATEGORY_EVENT = 'pvc:category-change';

  function normalizeCategory(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function readCategoriesJson(groupId) {
    const script = document.querySelector(
      `script[type="application/json"][data-pvc-categories="${groupId}"]`
    );
    if (!script) return [];

    try {
      const data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function getVideoRoots(groupId) {
    return Array.from(document.querySelectorAll('product-video-center-videos')).filter(
      (root) => (root.getAttribute('data-pvc-group') || 'main') === groupId
    );
  }

  function setCardVisible(card, visible) {
    card.classList.toggle('pvc-card--hidden', !visible);
    if (visible) {
      card.removeAttribute('hidden');
    } else {
      card.setAttribute('hidden', '');
    }
  }

  function renderPagination(root, currentPage, totalPages, matchedCount, perPage) {
    const nav = root.querySelector('.product-video-center__pagination');
    const list = root.querySelector('.product-video-center__pagination-list');
    const prevBtn = root.querySelector('[data-pvc-page="prev"]');
    const nextBtn = root.querySelector('[data-pvc-page="next"]');
    const showPagination = root.getAttribute('data-show-pagination') === 'true';

    if (!nav) return;

    const shouldShow = showPagination && matchedCount > perPage && totalPages > 1;
    nav.hidden = !shouldShow;
    if (!shouldShow) return;

    if (prevBtn) prevBtn.disabled = currentPage <= 1;
    if (nextBtn) nextBtn.disabled = currentPage >= totalPages;
    if (!list) return;

    list.innerHTML = '';

    for (let page = 1; page <= totalPages; page += 1) {
      const item = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-video-center__pagination-page';
      btn.textContent = String(page);
      btn.dataset.pvcPageNumber = String(page);
      btn.setAttribute('aria-label', `Page ${page}`);
      if (page === currentPage) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'page');
      }
      list.appendChild(item);
      item.appendChild(btn);
    }
  }

  function filterVideos(groupId, category, options = {}) {
    const normalized = normalizeCategory(category);
    if (!normalized) return;

    window.__pvcCategoryState = window.__pvcCategoryState || {};
    window.__pvcCategoryState[groupId] = normalized;

    getVideoRoots(groupId).forEach((root) => {
      const cards = Array.from(root.querySelectorAll('.pvc-card'));
      const showPagination = root.getAttribute('data-show-pagination') === 'true';
      const perPage = parseInt(root.getAttribute('data-videos-per-page'), 10) || 6;
      const emptyEl = root.querySelector('.product-video-center__empty');

      if (options.resetPage) {
        root.dataset.pvcCurrentPage = '1';
      }

      let currentPage = parseInt(root.dataset.pvcCurrentPage, 10) || 1;

      const searchQuery = (window.__pvcSearchQuery || '').trim().toLowerCase();
      const activeTags = window.__pvcActiveTags || new Set();
      window.__pvcActiveCategory = normalized;

      const matched = cards.filter((card) => {
        const cardCat = normalizeCategory(card.getAttribute('data-category'));
        if (cardCat !== normalized) return false;

        if (searchQuery) {
          const title = (card.querySelector('.pvc-card__title')?.textContent || '').toLowerCase();
          const tags = Array.from(card.querySelectorAll('.pvc-card__tag')).map(function (t) { return (t.textContent || '').trim().toLowerCase(); });
          if (!title.includes(searchQuery) && !tags.some(function (t) { return t.includes(searchQuery); })) return false;
        }

        if (activeTags.size > 0) {
          const cardTags = Array.from(card.querySelectorAll('.pvc-card__tag')).map(function (t) { return (t.textContent || '').trim(); });
          if (!Array.from(activeTags).every(function (t) { return cardTags.includes(t); })) return false;
        }

        return true;
      });

      const shouldPaginate = showPagination && matched.length > perPage;
      const totalPages = shouldPaginate ? Math.ceil(matched.length / perPage) : 1;

      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;
      root.dataset.pvcCurrentPage = String(currentPage);

      const usePagination = shouldPaginate;
      const start = usePagination ? (currentPage - 1) * perPage : 0;
      const end = usePagination ? start + perPage : matched.length;
      const visibleSet = new Set(matched.slice(start, end));



      cards.forEach((card) => {
        setCardVisible(card, visibleSet.has(card));
      });

      root.style.display = matched.length === 0 ? 'none' : '';

      renderPagination(root, currentPage, totalPages, matched.length, perPage);
    });

    updateTagDisplay();
    updateSearchClear();
  }

  function updateTagDisplay() {
    var tagsLabel = document.querySelector('.pvc-tags-label');
    var tagList = document.querySelector('.pvc-tag-list');
    var tagsClear = document.querySelector('.pvc-tags-clear');
    if (!tagList) return;

    var searchQuery = (window.__pvcSearchQuery || '').trim().toLowerCase();
    var activeTags = window.__pvcActiveTags || new Set();

    var allCards = Array.from(document.querySelectorAll('.pvc-card'));
    var category = window.__pvcActiveCategory || '';
    var searched = allCards.filter(function (card) {
      if (category) {
        if (normalizeCategory(card.getAttribute('data-category')) !== category) return false;
      }
      if (searchQuery) {
        var title = (card.querySelector('.pvc-card__title')?.textContent || '').toLowerCase();
        var cardTags = Array.from(card.querySelectorAll('.pvc-card__tag')).map(function (t) { return (t.textContent || '').trim().toLowerCase(); });
        if (!title.includes(searchQuery) && !cardTags.some(function (t) { return t.includes(searchQuery); })) return false;
      }
      return true;
    });

    var tagSet = new Set();
    searched.forEach(function (card) {
      Array.from(card.querySelectorAll('.pvc-card__tag')).forEach(function (tagEl) {
        var tag = (tagEl.textContent || '').trim();
        if (tag) tagSet.add(tag);
      });
    });
    activeTags.forEach(function (t) { tagSet.add(t); });
    var tags = Array.from(tagSet).sort(function (a, b) { return a.localeCompare(b); });

    if (tags.length) {
      if (tagsLabel) {
        tagsLabel.innerHTML = activeTags.size
          ? 'Filtering by <b>' + activeTags.size + '</b> tag' + (activeTags.size > 1 ? 's' : '') + ' · matching <b>all</b> selected'
          : 'Filter by tag — tap to combine (matches <b>all</b> selected)';
      }
      if (tagList) {
        tagList.innerHTML = tags.map(function (t) {
          var on = activeTags.has(t);
          return '<span class="pvc-chip' + (on ? ' is-on' : '') + '" data-tag="' + t.replace(/"/g, '&quot;') + '">' + t + (on ? '<span class="pvc-chip-x">✕</span>' : '') + '</span>';
        }).join('');
      }
    } else {
      if (tagsLabel) tagsLabel.innerHTML = '';
      if (tagList) tagList.innerHTML = '';
    }

    if (tagsClear) tagsClear.classList.toggle('is-visible', activeTags.size > 0);
  }

  function updateSearchClear() {
    var searchClear = document.querySelector('.pvc-search-clear');
    if (searchClear) {
      searchClear.classList.toggle('is-visible', !!(window.__pvcSearchQuery || '').trim());
    }
  }

  function activateTab(tab) {
    const categoriesRoot = tab.closest('product-video-center-categories');
    if (!categoriesRoot) return;

    const groupId = categoriesRoot.getAttribute('data-pvc-group') || 'main';
    const category = tab.getAttribute('data-category');

    categoriesRoot.querySelectorAll('.product-video-center__tab').forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    document.querySelectorAll('product-video-center-videos').forEach((root) => {
  const gid = root.getAttribute('data-pvc-group') || 'main';
  filterVideos(gid, category, { resetPage: true });
});

    document.dispatchEvent(
      new CustomEvent(PVC_CATEGORY_EVENT, {
        detail: {
          group: groupId,
          category: normalizeCategory(category),
        },
      })
    );
  }

  function initGroup(groupId) {
    const categoriesRoot = document.querySelector(
      `product-video-center-categories[data-pvc-group="${groupId}"]`
    );

    let category = window.__pvcCategoryState?.[groupId] || '';

    if (!category && categoriesRoot) {
      const activeTab =
        categoriesRoot.querySelector('.product-video-center__tab.is-active') ||
        categoriesRoot.querySelector('.product-video-center__tab');
      if (activeTab) category = activeTab.getAttribute('data-category');
    }

    if (!category) {
      const jsonCategories = readCategoriesJson(groupId);
      if (jsonCategories.length) category = jsonCategories[0].key;
    }

    if (!category && groupId !== 'main') {
      category = window.__pvcCategoryState?.['main'] || '';
    }

    if (category) {
      filterVideos(groupId, category, { resetPage: true });
    }
  }

  function initAll() {
    const groups = new Set();

    document.querySelectorAll('product-video-center-categories').forEach((el) => {
      groups.add(el.getAttribute('data-pvc-group') || 'main');
    });

    document.querySelectorAll('product-video-center-videos').forEach((el) => {
      groups.add(el.getAttribute('data-pvc-group') || 'main');
    });

    groups.forEach((groupId) => initGroup(groupId));
  }

  if (!window.__pvcVideoCenterListenersBound) {
    window.__pvcVideoCenterListenersBound = true;

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('.product-video-center__tab');
      if (tab) {
        window.__pvcActiveTags = new Set();
        activateTab(tab);
        return;
      }

      const chip = event.target.closest('.pvc-chip');
      if (chip) {
        var tag = chip.dataset.tag;
        if (!window.__pvcActiveTags) window.__pvcActiveTags = new Set();
        if (window.__pvcActiveTags.has(tag)) {
          window.__pvcActiveTags.delete(tag);
        } else {
          window.__pvcActiveTags.add(tag);
        }
        var activeTab = document.querySelector('.product-video-center__tab.is-active');
        if (activeTab) {
          var cat = activeTab.getAttribute('data-category');
          if (cat) {
            var allGroups = new Set();
            document.querySelectorAll('product-video-center-videos').forEach(function (el) {
              allGroups.add(el.getAttribute('data-pvc-group') || 'main');
            });
            allGroups.forEach(function (gid) {
              filterVideos(gid, cat, { resetPage: true });
            });
          }
        }
        return;
      }

      const tagsClearBtn = event.target.closest('.pvc-tags-clear');
      if (tagsClearBtn) {
        window.__pvcActiveTags = new Set();
        var activeTab = document.querySelector('.product-video-center__tab.is-active');
        if (activeTab) {
          var cat = activeTab.getAttribute('data-category');
          if (cat) {
            var allGroups = new Set();
            document.querySelectorAll('product-video-center-videos').forEach(function (el) {
              allGroups.add(el.getAttribute('data-pvc-group') || 'main');
            });
            allGroups.forEach(function (gid) {
              filterVideos(gid, cat, { resetPage: true });
            });
          }
        }
        return;
      }

      const pageBtn = event.target.closest('.product-video-center__pagination-page');
      if (pageBtn) {
        const videosRoot = pageBtn.closest('product-video-center-videos');
        if (!videosRoot) return;
        const groupId = videosRoot.getAttribute('data-pvc-group') || 'main';
        const category = window.__pvcCategoryState?.[groupId];
        if (!category) return;
        videosRoot.dataset.pvcCurrentPage = pageBtn.dataset.pvcPageNumber || '1';
        filterVideos(groupId, category, { resetPage: false });
        return;
      }

      const prevNext = event.target.closest('[data-pvc-page="prev"], [data-pvc-page="next"]');
      if (prevNext) {
        const videosRoot = prevNext.closest('product-video-center-videos');
        if (!videosRoot) return;
        const groupId = videosRoot.getAttribute('data-pvc-group') || 'main';
        const category = window.__pvcCategoryState?.[groupId];
        if (!category) return;

        let page = parseInt(videosRoot.dataset.pvcCurrentPage, 10) || 1;
        if (prevNext.dataset.pvcPage === 'prev') page -= 1;
        if (prevNext.dataset.pvcPage === 'next') page += 1;
        videosRoot.dataset.pvcCurrentPage = String(page);
        filterVideos(groupId, category, { resetPage: false });

        const grid = videosRoot.querySelector('.product-video-center__grid');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    document.addEventListener('shopify:section:load', () => {
      window.setTimeout(initAll, 0);
    });
  }

  window.PvcVideoCenter = {
    normalizeCategory,
    filterVideos,
    initAll,
  };

  var searchInput = document.querySelector('.pvc-search-box input');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      window.__pvcSearchQuery = this.value;
      var activeTab = document.querySelector('.product-video-center__tab.is-active');
      if (activeTab) {
        var cat = activeTab.getAttribute('data-category');
        if (cat) {
          var allGroups = new Set();
          document.querySelectorAll('product-video-center-videos').forEach(function (el) {
            allGroups.add(el.getAttribute('data-pvc-group') || 'main');
          });
          allGroups.forEach(function (gid) {
            filterVideos(gid, cat, { resetPage: true });
          });
        }
      }
    });
  }

  var searchClear = document.querySelector('.pvc-search-clear');
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      var input = document.querySelector('.pvc-search-box input');
      if (input) { input.value = ''; input.focus(); }
      window.__pvcSearchQuery = '';
      var activeTab = document.querySelector('.product-video-center__tab.is-active');
      if (activeTab) {
        var cat = activeTab.getAttribute('data-category');
        if (cat) {
          var allGroups = new Set();
          document.querySelectorAll('product-video-center-videos').forEach(function (el) {
            allGroups.add(el.getAttribute('data-pvc-group') || 'main');
          });
          allGroups.forEach(function (gid) {
            filterVideos(gid, cat, { resetPage: true });
          });
        }
      }
    });
  }

  var emptyTitleCards = document.querySelectorAll('.pvc-card[data-video-url]');
  emptyTitleCards.forEach(function (card) {
    var url = card.getAttribute('data-video-url');
    if (!url) return;
    var titleEl = card.querySelector('.pvc-card__title');
    if (!titleEl || (titleEl.textContent || '').trim()) return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://www.youtube.com/oembed?url=' + encodeURIComponent(url) + '&format=json', true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var data = JSON.parse(xhr.responseText);
          if (data && data.title) {
            titleEl.textContent = data.title;
            scheduleRefilter();
          }
        } catch (e) {}
      }
    };
    xhr.send();
  });

  var __pvcRefilterTimer = null;
  function scheduleRefilter() {
    if (__pvcRefilterTimer) clearTimeout(__pvcRefilterTimer);
    __pvcRefilterTimer = setTimeout(function () {
      var activeTab = document.querySelector('.product-video-center__tab.is-active');
      if (activeTab) {
        var cat = activeTab.getAttribute('data-category');
        if (cat) {
          var allGroups = new Set();
          document.querySelectorAll('product-video-center-videos').forEach(function (root) {
            allGroups.add(root.getAttribute('data-pvc-group') || 'main');
          });
          allGroups.forEach(function (gid) {
            filterVideos(gid, cat, { resetPage: true });
          });
        }
      }
    }, 300);
  }

  initAll();
});
